import { storeLoginSession } from '../../services/api';
import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import API from '../../services/api.js';
import BG from '../../assets/bg.png';
import Logo from '../../assets/Mask_group.png';
import ReCAPTCHA from 'react-google-recaptcha';
import KpmgLogo from '../../assets/KPMG_white_logo.svg'


const AdminLogin = () => {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);

  const navigate = useNavigate();
  const recaptchaRef = useRef();

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleCaptchaChange = (token) => {
    setRecaptchaToken(token);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!recaptchaToken) {
      setError("Please complete the CAPTCHA");
      return;
    }

    setLoading(true);
    const { username, password } = formData;

    try {
      const loginRes = await API.post(
        `${process.env.REACT_APP_DJANGO_API_URL}/admin-login/`,
        { email: username, password },
        { headers: { "Content-Type": "application/json" }, skipAuth: true }
      );

      const data = loginRes.data;

      if (!data.user) {
        setError("Invalid credentials");
        return;
      }

      await API.post('/verify-captcha/', { recaptcha_token: recaptchaToken }, { skipAuth: true });

      storeLoginSession(data);

      window.dispatchEvent(new Event("auth-state-changed"));
      navigate("/redirect");

    } catch (err) {
      const backendMessage = err?.response?.data?.error || err?.response?.data?.detail;
      setError(backendMessage || "Unexpected error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="bg-blue-900 bg-blend-multiply "
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "row",
        backgroundImage: `url(${BG})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundColor: "#1e3a8a",
      }}
    >
      {/* Header */}
      <div className="absolute z-20 items-center text-white w-full flex flex-row">
        <img className="aspect-square h-24" src={Logo} alt="Logo" />
        <div className='flex flex-col items-start justify-end gap-3 m-4 ml-0 mb-0'>
          <img src={KpmgLogo} alt='KPMG' className='h-8 w-auto cursor-pointer'/>
          <p className='text-sm text-white font-bold mb-4 cursor-pointer'>AI Security Posture Scanner</p>
        </div>
      </div>

      <div className="flex flex-row items-center h-screen w-full gap-[10vw]">
        {/* Left side steps */}
        <div className="text-white flex items-center flex-col w-1/2 mt-20 pl-[6vw]">
          <p className="mb-3 text-5xl font-bold">Get Started with Us</p>
          <p className="text-xl w-80 mb-4 text-center">
            Complete these easy steps to start using our LLM scanner
          </p>
          {["Sign up with our form", "Setup your workspace", "Start Scanning"].map((step, index) => (
            <div key={index} className="h-16 bg-black border border-white bg-opacity-30 w-96 rounded-xl flex flex-row items-center gap-2 mb-4">
              <div className="h-10 w-10 rounded-3xl text-black font-bold bg-white flex justify-center items-center aspect-square ml-2">
                <p>{index + 1}</p>
              </div>
              <p>{step}</p>
            </div>
          ))}
        </div>

        {/* Login Card */}
        <div className="w-1/2 flex items-center justify-center">
        <div className="bg-[#101012] border border-[#232325] rounded-2xl p-8 shadow-2xl">

          {/* Logo + Branding */}
          <div className="flex flex-row items-center mb-8">
            {/* <img
              src={Logo}
              alt="LLMinate logo"
              className="h-16 w-16 object-contain mb-3"
            /> */}
            <div className='flex flex-col items-start justify-end gap-3 m-4 mb-0 ml-0'>
              <img src={KpmgLogo} alt='KPMG' className='h-8 w-auto cursor-pointer'/>
              <p className='text-sm text-white font-bold mb-4 cursor-pointer'>AI Security Posture Scanner</p>
            </div>
          </div>

          {/* Heading */}
          <h2 className="text-xl font-semibold text-white mb-1">Sign in to your account</h2>
          <p className="text-gray-400 text-sm mb-6">Enter your credentials to continue</p>

          {/* Error Banner */}
          {error && (
            <div
              role="alert"
              className="mb-5 flex items-start gap-3 bg-red-500/10 border border-red-500/40 rounded-lg px-4 py-3"
            >
              <svg className="w-4 h-4 text-red-400 mt-0.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
              </svg>
              <p className="text-red-400 text-sm">{error}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5" noValidate>
            {/* Email */}
            <div>
              <label htmlFor="username" className="block text-sm font-medium text-gray-300 mb-1.5">
                Email address
              </label>
              <input
                id="username"
                type="email"
                name="username"
                autoComplete="email"
                placeholder="you@example.com"
                value={formData.username}
                onChange={handleChange}
                className={`w-full bg-[#1a1a1c] text-white placeholder-gray-600 border rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-colors ${
                  error ? 'border-red-500/60' : 'border-[#232325] focus:border-blue-500'
                }`}
              />
            </div>

            {/* Password */}
            <div>
              <div className="flex items-center justify-between mb-1.5">
                <label htmlFor="password" className="block text-sm font-medium text-gray-300">
                  Password
                </label>
                {/* <Link
                  to="/forgot-password"
                  className="text-xs text-blue-400 hover:text-blue-300 transition-colors"
                >
                  Forgot password?
                </Link> */}
              </div>
              <input
                id="password"
                type="password"
                name="password"
                autoComplete="current-password"
                placeholder="••••••••••••"
                value={formData.password}
                onChange={handleChange}
                className={`w-full bg-[#1a1a1c] text-white placeholder-gray-600 border rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-colors ${
                  error ? 'border-red-500/60' : 'border-[#232325] focus:border-blue-500'
                }`}
              />
            </div>

            {/* reCAPTCHA */}
            <div className="flex justify-center pt-1">
              <div className="scale-[0.88] origin-left sm:scale-100 sm:origin-center">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={process.env.REACT_APP_SITE_KEY}
                  onChange={handleCaptchaChange}
                  theme="dark"
                />
              </div>
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-600/50 disabled:cursor-not-allowed text-white font-semibold py-3 rounded-lg transition-colors text-sm"
            >
              {loading && (
                <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                </svg>
              )}
              {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>

          {/* Divider */}
          <div className="mt-6 pt-6 border-t border-[#232325] text-center">
            <p className="text-gray-500 text-xs">
              Securing AI systems through adversarial testing
            </p>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
